import { render, staticRenderFns } from "./Separator.vue?vue&type=template&id=4652d916&scoped=true&lang=pug&"
var script = {}
import style0 from "./Separator.vue?vue&type=style&index=0&id=4652d916&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4652d916",
  null
  
)

export default component.exports